var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment"},[_c('p',[_vm._v(" "+_vm._s(_vm.comment.content)+" "),_c('br'),_vm._v(" "+_vm._s(new Date(_vm.comment.posted).toLocaleString("pl-PL"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }